import _defineProperty from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["name", "options", "onChange", "selectedValue", "innerRef", "selectStyle", "dataCy"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { Icon } from '../../subkit-ui';
import classNames from 'classnames';
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var SelectNew = function SelectNew(_ref) {
  var name = _ref.name,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? [] : _ref$options,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? undefined : _ref$onChange,
      _ref$selectedValue = _ref.selectedValue,
      selectedValue = _ref$selectedValue === void 0 ? undefined : _ref$selectedValue,
      _ref$innerRef = _ref.innerRef,
      innerRef = _ref$innerRef === void 0 ? null : _ref$innerRef,
      _ref$selectStyle = _ref.selectStyle,
      selectStyle = _ref$selectStyle === void 0 ? {} : _ref$selectStyle,
      dataCy = _ref.dataCy,
      props = _objectWithoutProperties(_ref, _excluded);

  var onSelectionChange = function onSelectionChange(event) {
    if (onChange) {
      onChange(event.target.name, event.target.value);
    }
  };

  return /*#__PURE__*/_jsxs("div", {
    className: "relative",
    children: [/*#__PURE__*/_jsxs("select", _objectSpread(_objectSpread(_objectSpread({
      name: name,
      className: classNames('w-full p-3 my-1 font-sans border-neutral-200 rounded text-base appearance-none focus:outline-none focus:ring-1 focus:ring-subkit-primary focus:border-subkit-primary text-neutral-500', {
        'bg-gray-200': props.disabled
      }),
      onChange: onSelectionChange,
      value: selectedValue
    }, selectedValue ? {
      value: selectedValue
    } : {}), {}, {
      style: selectStyle,
      ref: innerRef,
      "data-cy": dataCy || name
    }, props), {}, {
      children: [!selectedValue && /*#__PURE__*/_jsx("option", {
        value: "",
        disabled: true,
        children: "Select your option"
      }), options.map(function (option) {
        return /*#__PURE__*/_jsx("option", {
          value: option.value,
          children: option.label
        }, option.value);
      })]
    })), /*#__PURE__*/_jsx("span", {
      className: "absolute inline-block h-full pointer-events-none",
      style: {
        right: '6px',
        top: '9px'
      },
      children: /*#__PURE__*/_jsx(Icon, {
        name: "chevron-down",
        type: "regular",
        className: "m-3 text-neutral-400"
      })
    })]
  });
};